<template>   
<div class="audit-detail" v-if="detail.auditState == 2 || detail.auditStatus == 2">     <i class="el-icon-warning"></i><span v-html="errorText"></span>   
</div> </template>

<script>
export default {
  name: "AuditDetail",
  props: {
    detail: {
      type: Object,
      default: function() { return {}},
    },
  },
  data() {
    return {
    }
  },
  components: {
  },
  computed: {
    errorText() {
      return `因内容审核不通过，建议修改后重新发布（${this.detail.auditRemark}）`
    }
  },
  mounted() {
  },
  methods: {

  },
  watch: {
  }
}
</script>

<style lang='scss' scoped>
  .audit-detail {
    margin-bottom: 16px;
    padding: 8px 15px;
    border: 1px solid #F8ABAB;
    color: #F34D4D;
    line-height: 22px;
    font-size: 12px;
    background: #FEF0F0;
    border-radius: 4px 4px 4px 4px;
    .el-icon-warning {
      margin-right: 7px;
      font-size: 14px;
    }
  }
</style>
